class Workshop3Activite1CsvGenerator {
  constructor(data, lang = "fr") {
    this.data = data || {};
    this.stakeholders = this.data.stakeholders || [];
    this.organizationName = this.data.organizationName || "Organization";
    this.lang = lang;
    this.labels = lang === "en" ? this.getEnLabels() : this.getFrLabels();
  }

  getFrLabels() {
    return {
      title: "ATELIER 3 - ACTIVITÉ 1 : PARTIES PRENANTES ET SOURCES DE MENACE",
      stakeholders: "PARTIES PRENANTES",
      name: "Nom",
      category: "Catégorie",
      type: "Type",
      threatLevel: "Niveau de menace",
      zone: "Zone",
      retained: "Retenu",
      description: "Description",
      internal: "Interne",
      external: "Externe",
      danger: "Zone de danger",
      control: "Zone de contrôle",
      watch: "Zone de veille",
      outside: "Hors périmètre",
      yes: "Oui",
      no: "Non",
      client: "Client",
      partner: "Partenaire",
      provider: "Fournisseur",
      technical: "Service technique",
      business: "Service métier",
      subsidiary: "Filiale",
    };
  }

  getEnLabels() {
    return {
      title: "WORKSHOP 3 - ACTIVITY 1: STAKEHOLDERS AND THREAT SOURCES",
      stakeholders: "STAKEHOLDERS",
      name: "Name",
      category: "Category",
      type: "Type",
      threatLevel: "Threat Level",
      zone: "Zone",
      retained: "Retained",
      description: "Description",
      internal: "Internal",
      external: "External",
      danger: "Danger Zone",
      control: "Control Zone",
      watch: "Watch Zone",
      outside: "Outside Scope",
      yes: "Yes",
      no: "No",
      client: "Client",
      partner: "Partner",
      provider: "Provider",
      technical: "Technical Service",
      business: "Business Service",
      subsidiary: "Subsidiary",
    };
  }

  createSectionHeader(title) {
    return `<tr><td colspan="10" style="background-color: #1E40AF; color: white; font-weight: bold; font-size: 14px; padding: 10px 8px;">${title}</td></tr>`;
  }

  createTableHeader(headers) {
    return `<tr>
            ${headers.map((h) => `<td style="background-color: #3B82F6; color: white; font-weight: bold; padding: 8px; border: 1px solid #93C5FD;">${h}</td>`).join("")}
        </tr>`;
  }

  createDataRow(cells) {
    return `<tr>
            ${cells.map((c) => `<td style="padding: 6px 8px; border: 1px solid #E2E8F0; vertical-align: top;">${c || ""}</td>`).join("")}
        </tr>`;
  }

  getZoneText(threatLevel) {
    const level = parseFloat(threatLevel) || 0;
    if (level >= 3) return this.labels.danger;
    if (level >= 1.5) return this.labels.control;
    if (level >= 0.5) return this.labels.watch;
    return this.labels.outside;
  }

  getZoneColor(threatLevel) {
    const level = parseFloat(threatLevel) || 0;
    if (level >= 3) return "background-color: #FEE2E2; color: #991B1B;";
    if (level >= 1.5) return "background-color: #FFEDD5; color: #9A3412;";
    if (level >= 0.5) return "background-color: #CCFBF1; color: #115E59;";
    return "background-color: #F1F5F9; color: #475569;";
  }

  getCategoryText(category) {
    const catMap = {
      client: this.labels.client,
      partner: this.labels.partner,
      provider: this.labels.provider,
      technical: this.labels.technical,
      business: this.labels.business,
      subsidiary: this.labels.subsidiary,
    };
    return catMap[category] || category;
  }

  getTypeText(type) {
    return type === "internal" ? this.labels.internal : this.labels.external;
  }

  generateStakeholdersSection() {
    if (!this.stakeholders || this.stakeholders.length === 0) {
      return (
        this.createSectionHeader(this.labels.stakeholders) +
        `<tr><td colspan="10" style="padding: 8px; color: #6B7280; font-style: italic;">${this.lang === "en" ? "No stakeholders defined" : "Aucune partie prenante définie"}</td></tr>`
      );
    }

    const headers = [
      this.labels.name,
      this.labels.category,
      this.labels.type,
      this.labels.threatLevel,
      this.labels.zone,
      this.labels.retained,
      this.labels.description,
    ];

    const rows = this.stakeholders
      .map((s) => {
        const zoneText = this.getZoneText(s.threatLevel);
        const zoneColor = this.getZoneColor(s.threatLevel);
        return this.createDataRow([
          s.name || "",
          this.getCategoryText(s.category),
          this.getTypeText(s.type),
          s.threatLevel || "0",
          `<span style="${zoneColor} padding: 2px 6px; border-radius: 4px;">${zoneText}</span>`,
          s.retained ? this.labels.yes : this.labels.no,
          s.description || "",
        ]);
      })
      .join("");

    return (
      this.createSectionHeader(this.labels.stakeholders) +
      this.createTableHeader(headers) +
      rows
    );
  }

  generateHtml() {
    const sections = [this.generateStakeholdersSection()];

    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<style>
    table { border-collapse: collapse; width: 100%; font-family: Calibri, Arial, sans-serif; }
    tr:nth-child(even) td { background-color: #F8FAFC; }
    tr:hover td { background-color: #EFF6FF; }
    tr { page-break-inside: avoid; }
</style>
</head>
<body>
<table>
${sections.join("\n\n")}
</table>
</body>
</html>`;
  }

  download(filename) {
    const htmlContent = this.generateHtml();
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + htmlContent], {
      type: "application/vnd.ms-excel;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 0);
  }
}

export default Workshop3Activite1CsvGenerator;
